import React, {Fragment} from 'react';

const AuthRedirectionScreen = () => {
    return (
        <Fragment />
    );
};

export default AuthRedirectionScreen;
